import { Component, computed, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../service/loading.service';


@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  isLoading = computed(() => this.loadingService.loading());

  constructor(private loadingService: LoadingService) {
    effect(() => this.isLoading());
  }
}
